__turbopack_context__.v({
  "alertMenuOption": "ScNavbar-module__eQVP-G__alertMenuOption",
  "cardAlert": "ScNavbar-module__eQVP-G__cardAlert",
  "coral": "ScNavbar-module__eQVP-G__coral",
  "jello": "ScNavbar-module__eQVP-G__jello",
  "jello-horizontal": "ScNavbar-module__eQVP-G__jello-horizontal",
  "nav": "ScNavbar-module__eQVP-G__nav",
  "normalCard": "ScNavbar-module__eQVP-G__normalCard",
  "ping": "ScNavbar-module__eQVP-G__ping",
  "verticalPipe": "ScNavbar-module__eQVP-G__verticalPipe",
  "whatsNewIconBlink": "ScNavbar-module__eQVP-G__whatsNewIconBlink",
});
